var $a4cd257e892b5fbb$exports = {};
$a4cd257e892b5fbb$exports = {
    "colorSwatchPicker": `Vzorkovn\xedky farieb`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`
};


export {$a4cd257e892b5fbb$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
